import { render, staticRenderFns } from "./PdfDownload.vue?vue&type=template&id=63d16a08&scoped=true"
import script from "./PdfDownload.ts?vue&type=script&lang=ts&external"
export * from "./PdfDownload.ts?vue&type=script&lang=ts&external"
import style0 from "./PdfDownload.scss?vue&type=style&index=0&id=63d16a08&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d16a08",
  null
  
)

export default component.exports